import { AO, BR, CG, DK, GB, NG } from 'country-flag-icons/react/3x2';
import { CountryData } from 'types/wellGuardian';

const CountryFlagIcon = (country: string) => {
  if (country === CountryData.unitedKingdom) {
    return (
      <div data-testid="uk_flag_tag">
        <GB
          style={{
            display: 'inline-block',
            height: '1.5em',
            width: '2em',
            marginRight: '8px',
          }}
        />
      </div>
    );
  }
  if (country === CountryData.denmark) {
    return (
      <DK
        style={{
          display: 'inline-block',
          height: '1.5em',
          width: '2em',
          marginRight: '8px',
        }}
      />
    );
  }
  if (country === CountryData.nigeria) {
    return (
      <NG
        style={{
          display: 'inline-block',
          height: '1.5em',
          width: '2em',
          marginRight: '8px',
        }}
      />
    );
  }
  if (country === CountryData.angola) {
    return (
      <AO
        style={{
          display: 'inline-block',
          height: '1.5em',
          width: '2em',
          marginRight: '8px',
        }}
      />
    );
  }
  if (country === CountryData.congo) {
    return (
      <CG
        style={{
          display: 'inline-block',
          height: '1.5em',
          width: '2em',
          marginRight: '8px',
        }}
      />
    );
  }
  if (country === CountryData.brazil) {
    return (
      <BR
        style={{
          display: 'inline-block',
          height: '1.5em',
          width: '2em',
          marginRight: '8px',
        }}
      />
    );
  }
};

export default CountryFlagIcon;
